import { Action, Reducer } from 'redux';
import { ApplicationState } from './../models/ApplicationState';
import { applicationDataReducer, defaultApplicationState as appState } from './form/applicationDataReducer';
import { formDataReducer } from './form/formDataReducer';
import { submissionDataReducer } from './submission/submissionDataReducer';

export const defaultApplicationState: ApplicationState = appState;

const rootReducer: Reducer<ApplicationState> = (
    state: ApplicationState = defaultApplicationState,
    action: Action,
): ApplicationState => {
    // add new state elements here
    return {
        ... applicationDataReducer(state, action),
        formState: formDataReducer(state.formState, action),
        submissionState: submissionDataReducer(state.submissionState, action)
    };
};

export default rootReducer;
